import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
//from :https://vue-toastification.maronato.dev/
export default {
  install(Vue, options) {
    Vue.use(Toast, {
      transition: "Vue-Toastification__fade",
      maxToasts: 3,
      newestOnTop: true,
      position: "bottom-right",
      timeout: 2000,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: true,
      hideProgressBar: false,
      closeButton: "button",
      icon: true,
      rtl: false,
      ...options,
    });
  },
};
